import React, { useCallback } from 'react'
import ReactGA from 'react-ga'
import { useNavigation } from '@react-navigation/native'
import { useSelector, useDispatch } from 'react-redux'

import AuthContainer from '../../navigation/layouts/Auth/AuthContainer'
import ForgotPasswordForm from './ForgotPasswordForm'

import forgotPasswordActions from '../../redux/forgotPassword/forgotPasswordActions'
import { forgotPasswordLoadSelector } from '../../redux/forgotPassword/forgotPasswordSelector'

ReactGA.pageview('/forgot-password')

const ForgotPassword = () => {
  const navigation = useNavigation()
  const dispatch = useDispatch()
  const loading = useSelector(forgotPasswordLoadSelector)

  const onForgotPassword = useCallback(payload => {
    dispatch(forgotPasswordActions.sendForgotPasswordEmail(payload))
  }, [dispatch])

  const navigateBack = () => {
    navigation.navigate('login')
  }

  return (
    <AuthContainer onNavigateBack={navigateBack}>
      <ForgotPasswordForm
        loading={loading}
        onForgotPassword={onForgotPassword}
      />
    </AuthContainer>

  )
}

export default ForgotPassword
